export const EXPENSE_VAT_RATE_PERCENT_MAX = 100

/** Keeps expense VAT rate within DB-safe bounds before draft/submit API calls. */
export function normalizeExpenseVatRateForApi(input: {
  vatRate?: unknown
  vat_rate?: unknown
  amountExclVat?: unknown
  amount_excl_vat?: unknown
  vatAmount?: unknown
  vat_amount?: unknown
}): number {
  const direct = Number(input.vatRate ?? input.vat_rate)
  if (Number.isFinite(direct) && direct >= 0 && direct <= EXPENSE_VAT_RATE_PERCENT_MAX) {
    return Math.round(direct * 100) / 100
  }

  const ht = Number(input.amountExclVat ?? input.amount_excl_vat)
  const vat = Number(input.vatAmount ?? input.vat_amount)
  if (Number.isFinite(ht) && ht > 0 && Number.isFinite(vat) && vat >= 0) {
    const derived = (vat / ht) * 100
    if (Number.isFinite(derived)) {
      return Math.min(EXPENSE_VAT_RATE_PERCENT_MAX, Math.round(derived * 100) / 100)
    }
  }

  if (Number.isFinite(direct) && direct >= 0) {
    return Math.min(EXPENSE_VAT_RATE_PERCENT_MAX, Math.round(direct * 100) / 100)
  }

  return 0
}

export function isExpenseImpliedVatRateValid(amountExclVat: number, vatAmount: number): boolean {
  if (!(amountExclVat > 0) || !(vatAmount >= 0)) return true
  return (vatAmount / amountExclVat) * 100 <= EXPENSE_VAT_RATE_PERCENT_MAX
}
